/* APP ************************************************************************/


// libs
import Cookies from 'js-cookie'

// Util
import { getParam } from 'util/url'
import { randomString } from 'util/string'
import * as Taskrunner from 'util/taskrunner'

// actions
import { init } from 'react-redux/actions/language'
import { stopDrag } from 'react-redux/actions/drag-and-drop'
import {
  fetchItems as fetchPlaylistItems
} from 'react-redux/actions/playlist'
import {
  fetchItems as fetchMediaPlayerItems,
  fetchStatus as fetchMediaPlayerStatus
} from 'react-redux/actions/media-player'
import {
  fetch as fetchUser,
  reset as resetUser
} from 'react-redux/actions/user'



import { SUCCESS_SUFFIX, FAIL_SUFFIX, PROGRESS_SUFFIX } from 'util/dataprovider'
import { makeAction } from 'util/reduxhelper'

// components
import * as VIEW from 'component/app/view'

// constants
const COOKIE_FLAG_PATH = 'app.cookieOptIn'



let loginStateMonitoringTask
const LOGIN_STATE_MONITORING_INTERVAL = 3e4

/* INITIALIZATION *************************************************************/

/**
* Application Startup Action
* Checks URL for reset_token param and toggles view
* invokes initialization procedure
**/
export const APPLICATION_STARTUP = 'app/APPLICATION_STARTUP'
export const applicationStartup = () => {
  return (dispatch, getState) => {
    return
    dispatch({ type: APPLICATION_STARTUP })
    dispatch(fetchCookieOptIn())
    dispatch(init())
    var resetToken = getParam('reset_token')
    if (resetToken) {
      dispatch(setView(VIEW.PASSWORDRESET))
    } else {
      dispatch(fetchUser())
    }


    if (!loginStateMonitoringTask) {
      loginStateMonitoringTask = Taskrunner.addTask(
        (task) => {
          dispatch(fetchUser())
        },
        (task) => {
          if(!getState().user.loggedIn) return false
          if( Date.now() - task.lastRun > LOGIN_STATE_MONITORING_INTERVAL ) {
            return true
          }
          return false
        }
      )
    }

  }
}

/* DATA ***********************************************************************/

/**
* Invokes the fetch procedures of all (yes, all!) different domains
* This means the entire Database is loaded by the client
* @todo Replace with another strategy
**/
export const FETCH_ALL = 'app/FETCH_ALL'
export const fetchAll = () => {
  return dispatch => {
    dispatch({ type: FETCH_ALL })
    //dispatch(fetchAssetItems())
    //dispatch(fetchPlaylistItems())
    //dispatch(fetchMediaPlayerItems())
    //dispatch(fetchMediaPlayerStatus())
  }
}

/**
* Resets the Application
**/
export const RESET = 'app/RESET'
export const reset = () => {
  return dispatch => {
    dispatch(resetUser())
    dispatch({ type: RESET })
  }
}

/* VIEW ***********************************************************************/

/**
* Changes the Application View
**/
export const SET_VIEW = 'app/SET_VIEW'
export const setView = (view) => {
  return { type: SET_VIEW, view }
}


/* GLOBAL FILTER ***************************************************************/

/* Fetch */
export const FETCH_FILTER = 'app/FETCH_FILTER'
export const fetchFilter = () => {
  return makeAction(FETCH_FILTER)
}
/* automated for convenience @see dataprovider */
export const FETCH_FILTER_FAIL = FETCH_FILTER + FAIL_SUFFIX
export const FETCH_FILTER_SUCCESS = FETCH_FILTER + SUCCESS_SUFFIX

/* Save */
export const SAVE_FILTER = 'app/SAVE_FILTER'
export const saveFilter = (filter) => {
  return makeAction(SAVE_FILTER, filter)
}
/* automated for convenience @see dataprovider */
export const SAVE_FILTER_FAIL = SAVE_FILTER + FAIL_SUFFIX
export const SAVE_FILTER_SUCCESS = SAVE_FILTER + SUCCESS_SUFFIX
/* COOKIE *********************************************************************/

/**
* Parse the Cookie to determine if Cookies are allowed.
**/
/*export const FETCH_COOKIE_OPT_IN = 'app/FETCH_COOKIE_OPT_IN'
export const fetchCookieOptIn = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_COOKIE_OPT_IN })
    const cookieOptIn = Cookies.getJSON(COOKIE_FLAG_PATH)
    if(cookieOptIn) dispatch(allowCookie())
  }
}*/
/* Fetch */
export const FETCH_COOKIE_OPT_IN = 'cookieOptIn/FETCH_COOKIE_OPT_IN'
export const fetchCookieOptIn = () => {
  return makeAction(FETCH_COOKIE_OPT_IN)
}
/* automated for convenience @see dataprovider */
export const FETCH_COOKIE_OPT_IN_FAIL = FETCH_COOKIE_OPT_IN + FAIL_SUFFIX
export const FETCH_COOKIE_OPT_IN_SUCCESS = FETCH_COOKIE_OPT_IN + SUCCESS_SUFFIX


/* Fetch */
export const SAVE_COOKIE_OPT_IN = 'cookieOptIn/SAVE_COOKIE_OPT_IN'
export const saveCookieOptIn = (val) => {
  return makeAction(SAVE_COOKIE_OPT_IN, val)
}
/* automated for convenience @see dataprovider */
export const SAVE_COOKIE_OPT_IN_FAIL = SAVE_COOKIE_OPT_IN + FAIL_SUFFIX
export const SAVE_COOKIE_OPT_IN_SUCCESS = SAVE_COOKIE_OPT_IN + SUCCESS_SUFFIX


/**
* Toggles the allow cookie flag
* deprecated
* TODO remove
**/
export const ALLOW_COOKIE = 'app/ALLOW_COOKIE'
export const allowCookie = () => {
  return (dispatch) => {
    dispatch({ type: ALLOW_COOKIE })
  }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/actions/app.js